/* Produktfinder für die Shopsuche (PO 11732 und 11747, 25.10.2026).
 *
 * Die Shopify-Suche bewertet Ähnlichkeit, nicht Genauigkeit: "Fiorenzato F4
 * EVO" brachte zehnmal F64 und F83, die F4 nicht. Dieses Skript sucht den
 * Begriff zusätzlich in assets/nb-produktfinder.json (gebaut von
 * scripts/suche/produktfinder-index.mjs im Repo naturbohne-advisor) und
 * setzt genaue Treffer im Suchfenster und auf der Suchseite nach oben.
 *
 * Der Index wird erst bei der ersten Eingabe geladen. Bild und Preis kommen
 * für die angezeigten Treffer aus /products/<handle>.js.
 *
 * Regeln: Ein genauer Name wird immer gezeigt, und dann nur genaue Namen.
 * Namen, die mit der Eingabe beginnen, und Treffer, bei denen nur alle
 * Wörter vorkommen, nur bei höchstens drei Produkten, sonst wäre es
 * Rauschen. Mindestens 3 Zeichen.
 */
(function () {
  if (window.nbProduktfinder) return;
  var script = document.currentScript;
  var INDEX_URL = script && script.dataset.index;
  var UEBERSCHRIFT = (script && script.dataset.ueberschrift) || 'Genau gesucht';
  var indexPromise = null;
  var produktCache = {};

  /* Muss zu norm() in scripts/suche/produktfinder-index.mjs passen. */
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
      .replace(/\+{2,}[^+]*\+{2,}/g, ' ')
      .replace(/[^a-z0-9.]+/g, ' ')
      .replace(/(^|\s)\.+|\.+(\s|$)/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function ladeIndex() {
    if (!indexPromise) {
      indexPromise = fetch(INDEX_URL, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          j.k.forEach(function (e) { e.push(e[0].split(' ')); });
          return j;
        })
        .catch(function () { indexPromise = null; return null; });
    }
    return indexPromise;
  }

  function suche(index, eingabe) {
    var q = norm(eingabe);
    if (q.length < 3) return [];
    var qw = q.split(' ');
    var beste = {};
    index.k.forEach(function (e) {
      var key = e[0], score = 0, nurExakt = e[3] === 1;
      if (key === q) score = 100;
      else if (nurExakt) return;
      else if (key.indexOf(q + ' ') === 0 || (key.indexOf(q) === 0 && q.length >= 4)) score = 80;
      else {
        var kw = e[e.length - 1];
        var alle = qw.every(function (w) {
          return kw.some(function (k) { return k === w || (w.length >= 3 && k.indexOf(w) === 0); });
        });
        if (alle) score = 60 + Math.round((qw.length / kw.length) * 10);
      }
      if (!score) return;
      var vid = e[2] ? String(e[2]) : null;
      var bisher = beste[e[1]];
      if (!bisher || score > bisher.score) beste[e[1]] = { i: e[1], score: score, vid: vid };
    });
    var treffer = Object.keys(beste).map(function (k) { return beste[k]; });
    treffer.sort(function (a, b) { return b.score - a.score; });
    /* Genaue Namen schlagen alles andere. Sonst nur zeigen, wenn die
       Eingabe eindeutig genug ist (höchstens drei Produkte), damit
       "eureka mignon" nicht drei zufällige Mignons nach oben schiebt. */
    var genau = treffer.filter(function (t) { return t.score === 100; });
    if (genau.length) return genau.slice(0, 3);
    var stark = treffer.filter(function (t) { return t.score >= 80; });
    if (stark.length) return stark.length <= 3 ? stark : [];
    return treffer.length <= 3 ? treffer : [];
  }

  function produkt(handle) {
    if (!produktCache[handle]) {
      produktCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return produktCache[handle];
  }

  function preis(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch (e) { return ''; }
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function baue(index, treffer) {
    return Promise.all(treffer.map(function (t) {
      var p = index.p[t.i];
      return produkt(p[0]).then(function (d) { return { t: t, p: p, d: d }; });
    })).then(function (liste) {
      var zeilen = liste.filter(function (x) { return x.d && x.d.available !== undefined; }).map(function (x) {
        var d = x.d;
        var variante = x.t.vid && d.variants ? d.variants.filter(function (v) { return String(v.id) === x.t.vid; })[0] : null;
        var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + d.handle + (variante ? '?variant=' + variante.id : '');
        var bild = (variante && variante.featured_image && variante.featured_image.src) || d.featured_image || '';
        if (bild) bild = bild.split('?')[0] + '?width=120';
        var titel = d.title + (variante && variante.title !== 'Default Title' ? ' · ' + variante.title : '');
        var cents = variante ? variante.price : d.price;
        return '<a class="nb-pf__zeile" href="' + esc(url) + '">' +
          (bild ? '<img class="nb-pf__bild" src="' + esc(bild) + '" alt="" width="60" height="60" loading="lazy">' : '<span class="nb-pf__bild"></span>') +
          '<span class="nb-pf__text"><span class="nb-pf__vendor">' + esc(d.vendor || '') + '</span>' +
          '<span class="nb-pf__titel">' + esc(titel) + '</span>' +
          '<span class="nb-pf__preis">' + esc(preis(cents)) + '</span></span></a>';
      });
      if (!zeilen.length) return null;
      var div = document.createElement('div');
      div.className = 'nb-pf grid gap-3 md:gap-4 w-full';
      div.innerHTML = '<p class="search__heading block text-xs uppercase leading-tight tracking-widest">' + esc(UEBERSCHRIFT) + '</p>' + zeilen.join('');
      return div;
    });
  }

  var laufend = new WeakMap();

  function zeigeIn(container, eingabe, oben) {
    var token = {};
    laufend.set(container, token);
    ladeIndex().then(function (index) {
      if (!index || laufend.get(container) !== token) return;
      var treffer = suche(index, eingabe);
      var alt = container.querySelector(':scope > .nb-pf');
      if (!treffer.length) { if (alt) alt.remove(); return; }
      baue(index, treffer).then(function (div) {
        if (laufend.get(container) !== token) return;
        var alt2 = container.querySelector(':scope > .nb-pf');
        if (alt2) alt2.remove();
        if (div) container.insertBefore(div, oben ? container.firstChild : container.firstChild);
      });
    });
  }

  /* Suchfenster: nach jedem Neuzeichnen der Ergebnisse einsetzen. */
  function beobachte(container) {
    var form = container.closest('form');
    var input = form && form.querySelector('input[type="search"]');
    if (!input) return;
    new MutationObserver(function (m) {
      if (container.querySelector(':scope > .nb-pf') && m.every(function (x) {
        return Array.prototype.every.call(x.addedNodes, function (n) { return n.classList && n.classList.contains('nb-pf'); });
      })) return;
      if (!container.querySelector(':scope > *')) return;
      zeigeIn(container, input.value, true);
    }).observe(container, { childList: true });
    input.addEventListener('input', function () { if (input.value.trim().length >= 3) ladeIndex(); });
  }

  function start() {
    document.querySelectorAll('[id^="PredictiveSearchResults-"]').forEach(beobachte);
    /* Suchseite */
    var grid = document.getElementById('ProductGridContainer');
    var q = new URLSearchParams(location.search).get('q');
    if (grid && q && /\/search/.test(location.pathname)) {
      var box = document.createElement('div');
      box.className = 'nb-pf-seite';
      grid.insertBefore(box, grid.firstChild);
      zeigeIn(box, q, true);
    }
  }

  window.nbProduktfinder = { norm: norm, suche: function (q) { return ladeIndex().then(function (i) { return i ? suche(i, q) : []; }); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
